import { withPrefix } from 'utils/prefix'

const pruneSelfReferences = (documents, parent = null) => {
	return documents.map(document => {
		if (!document.items || document.items.length === 0) {
			return document
		}

		return {
			...document,
			// section: parent ? parent.url : undefined,
			items: pruneSelfReferences(
				document.items.filter(itm => itm.label !== 'index'),
				document,
			),
		}
	})
}

const getNestedDocuments = (path, treeItems) => {
	let documents = []
	if (!path) {
		return documents
	}

	const pathWithoutTrailingSlash = `${path.substr(-1) === '/' ? path.slice(0, -1) : path}`

	const loop = (path, items) => {
		items.forEach(tree => {
			if (!(withPrefix(tree.url) === pathWithoutTrailingSlash && tree.label !== 'index')) {
				return loop(path, tree.items)
			}
			documents = tree.items
		})
	}

	loop(path, treeItems)

	return pruneSelfReferences(documents)
}

export default getNestedDocuments
